import { useEffect, useState } from 'react';

/**
 * A tick independent of MQTT message arrival, so age/staleness displays
 * advance even when nothing new has been published. If this itself stalls
 * (tab frozen/suspended), that's a distinct, visible "the page itself is
 * stuck" cue from per-field staleness.
 */
export function useClock(intervalMs = 250) {
  const [nowMs, setNowMs] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNowMs(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);

  return nowMs;
}
